import { TitleAlignment, TitleAlignmentThemeStyleType } from "modules/Types";

/**
 * Configuration object containing all available title alignment theme styles
 * @constant
 * @type {Record<string, TitleAlignmentThemeStyleType>}
 * @property {TitleAlignmentThemeStyleType} left - Left alignment option
 * @property {TitleAlignmentThemeStyleType} center - Center alignment option 
 * @property {TitleAlignmentThemeStyleType} right - Right alignment option
 */
export const titleAlignmentThemeStyles: Record<TitleAlignment, TitleAlignmentThemeStyleType> = {
    left: {
        title: "Left",
        name: "left", 
        order: 1,
    },
    center: {
        title: "Center",
        name: "center",
        order: 2,
    },
    right: {
        title: "Right",
        name: "right",
        order: 3,
    },
} as const;